import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/header/header";
import moment from "moment";
import Request from "../core/httpClient";
import { Consumer } from "../context";
import Chart from "react-chartjs-2";
const req = new Request();

class Interactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment()
        .add(-7, "day")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      empty: true,
      user: {
        idTienda: 0,
        nombre: "",
        usuario: ""
      },
      dataResult: [],

      typeChartPeticiones: "",
      dataChartPeticiones: {},

      optionsChart: {},
      maxValue: 6
    };
  }

  async componentDidMount() {
    await this.load();
    await this.setOptionChart(this.state.maxValue);
    await this.getReport();
  }

  async load() {
    const user = await this.props.context.loadUser();

    if (user) {
      this.setState({
        user: {
          id_tienda: user.id.id_tienda,
          nombre: user.id.nombre,
          usuario: user.id.usuario
        }
      });
    }
  }

  startChange(event) {
    this.setState({ startDate: event.target.value });
  }

  endChange(event) {
    this.setState({ endDate: event.target.value });
  }

  async getReport(event) {
    if (event) {
      event.preventDefault();
    }

    this.setState({ loading: true });

    const data = {
      desde: this.state.startDate,
      hasta: this.state.endDate,
      id_tienda: this.state.user.id_tienda
    };

    const res = await req.post("/tiendas/getAllVisitas", data);

    if (res.peticiones) {
      this.setState({ dataResult: res.peticiones, empty: false });
      this.setChartPeticiones();
      this.setState({ loading: false });
    }

    if (res.empty) {
      this.setState({ empty: res.empty, loading: false });
    }
  }

  async setChartPeticiones() {
    let labelsChart = [];
    let dsChart = [];
    let contfecha = 0;


    this.state.dataResult.map(row => {
      labelsChart.push(row.Fecha);
      dsChart.push(row.Interaction);

      return "OK";
    });

    this.setState({
      typeChartPeticiones: "line",
      dataChartPeticiones: {
        labels: labelsChart,
        datasets: [
          {
            data: dsChart,
            fill: false,
            lineTension: 0
          }
        ]
      }
    });
  }

  async setOptionChart(newMaxValue) {
    this.setState({
      maxValue: newMaxValue,
      optionsChart: {
        elements: {
          line: {
            borderColor:
              process.env.REACT_APP_NAME === "iGate"
                ? "rgba(234, 66, 53, 1.0)"
                : "rgba(234, 84, 95, 1.0)"
          }
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return "";
            },
            label: function(tooltipItem, data) {
              return tooltipItem.label + " - " + tooltipItem.value;
            }
          },
          backgroundColor:
            process.env.REACT_APP_NAME === "iGate"
              ? "rgba(234, 66, 53, 1.0)"
              : "rgba(234, 84, 95, 1.0)",
          displayColors: false
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxTicksLimit: 7,
                maxRotation: 0,
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 7,
                min: 0,
                max: newMaxValue
                //stepSize: 1
              }
            }
          ]
        }
      }
    });
  }

  render() {
    return (
      <div className="admin interactions column">
        <Helmet>
          <title>{process.env.REACT_APP_NAME} - Interacciones</title>
        </Helmet>
        <Header nav={"interacciones"} />
        <div className="row justify-center">
          <div className="column" id="content">
            <div className="justify-center">
              <div className="container column text-justify">
                <div className="white-space-32"></div>
                <div className="navigation align-center">
                  <div className="justify-start">
                    <h3 className="weight-semi">Interacciones</h3>
                  </div>
                </div>
                <div className="white-space-8"></div>
                <div className="filter-date row-responsive">
                  <form
                    className="get-reports row-responsive"
                    onSubmit={this.getReport.bind(this)}
                  >
                    <div className="data-from column">
                      <h5 className="color-black">DESDE:</h5>
                      <div className="white-space-8" />
                      <input
                        type="date"
                        id="startdate"
                        name="startdate"
                        className="input input-select"
                        placeholder="Desde"
                        value={this.state.startDate}
                        onChange={this.startChange.bind(this)}
                      />
                    </div>
                    <div className="data-to column">
                      <h5 className="color-black">HASTA:</h5>
                      <div className="white-space-8" />
                      <input
                        type="date"
                        id="enddate"
                        name="enddate"
                        className="input input-select"
                        placeholder="Hasta"
                        value={this.state.endDate}
                        onChange={this.endChange.bind(this)}
                      />
                    </div>
                    <div className="get-result justify-start align-end">
                      <button className="btn btn-primary btn-small">
                        {!this.props.loading ? (
                          <i className="fas fa-search" />
                        ) : (
                          <i className="fas fa-spinner fa-spin" />
                        )}
                        &nbsp; Obtener
                      </button>
                    </div>
                  </form>
                  <div className="get-results justify-end align-end"></div>
                </div>
                <div className="white-space-16"></div>
                {this.state.loading ? (
                  <React.Fragment>
                    <div className="white-space-32"></div>
                    <div className="row justify-center">
                      <i className="fas fa-spinner fa-spin"></i>
                    </div>
                  </React.Fragment>
                ) : !this.state.empty ? (
                  <React.Fragment>
                    <div className="card-table-big ">
                      <div className="row align-center justify-start">
                        <i className="far fa-eye"></i>
                        <h4 className="weight-semi">Visitas</h4>
                      </div>
                      <Chart
                        type={this.state.typeChartPeticiones}
                        data={this.state.dataChartPeticiones}
                        options={this.state.optionsChart}
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="white-space-48"></div>
                    <div className="justify-center">
                      <h3>No se encontraron resultados.</h3>
                    </div>
                  </React.Fragment>
                )}
                <div className="white-space-32"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Consumer(Interactions);
